import { createContext, useContext, ReactNode } from 'react';

interface GlobalFABContextType {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
}

const GlobalFABContext = createContext<GlobalFABContextType | undefined>(undefined);

interface GlobalFABProviderProps {
  children: ReactNode;
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
}

export const GlobalFABProvider = ({ children, isVisible, setIsVisible }: GlobalFABProviderProps) => {
  return <GlobalFABContext.Provider value={{ isVisible, setIsVisible }}>{children}</GlobalFABContext.Provider>;
};

export const useGlobalFAB = () => {
  const context = useContext(GlobalFABContext);
  if (context === undefined) {
    throw new Error('useGlobalFAB must be used within a GlobalFABProvider');
  }
  return context;
};
